import { createContext } from 'react';

export const PreviewContext = createContext(null);

export const PreviewContextProvider = PreviewContext.Provider;
